import styled from "styled-components"
import { getCssSizeValue, getPropSafely, parseDatoText } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Image from "@/components/common/Image"
import { IMAGE_FALLBACK } from "@/constants"
import React, { useMemo } from "react"
import useDevice, { useIsMobile } from "@/hooks/useDevice"
import GridContainer from "@/components/common/GridContainer"
import AssetWrapper from "@/components/Banners/SubPage/Components/AssetWrapper"
import dynamic from "next/dynamic"
const PaymentBlock = dynamic(() => import("@/components/Banners/SubPage/Components/PaymentBlock"), { ssr: false })

const Wrapper = styled.section`
	overflow: hidden;
	position: relative;
	min-height: 100svh;
	width: 100%;
	display: flex;
	align-items: end;

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding-bottom: ${getCssSizeValue(160)};
		align-items: end;
	}
`

const StyledGridContainer = styled(GridContainer)`
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 1;
	background: ${({ theme }) => theme.colors.platinum};
	padding-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		background: transparent;
		padding-bottom: unset;
	}
`

const HiddenHeading1 = styled.h1`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0 0 0 0);
	border: 0;
	white-space: nowrap;
`

export default function PaymentBanner({ data }) {
	const isMobile = useIsMobile()
	const orientation = useDevice("orientation")

	const paymentModuleData = getPropSafely(data, "selectPaymentModule", null)
	const image = useMemo(() => {
		const image = orientation === "landscape" ? data?.image : data?.imageVertical
		return image || data?.image || IMAGE_FALLBACK
	}, [orientation, data])
	return (
		<Wrapper>
			<HiddenHeading1>{parseDatoText(data?.header || "")}</HiddenHeading1>
			<AssetWrapper>
				<Image
					src={image.url}
					alt={image.alt}
					priority
					placeholder={image.blurUpThumb}
					focalPoint={image.focalPoint}
					sizes="100vw"
					quality={100}
				/>
			</AssetWrapper>

			<StyledGridContainer className={`indent-desktop-8 ${isMobile ? "no-margin" : ""}`}>
				{paymentModuleData && <PaymentBlock data={paymentModuleData} />}
			</StyledGridContainer>
		</Wrapper>
	)
}